import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfirmProvider } from './components/ConfirmDialog';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </I18nextProvider>
  </StrictMode>,
);

// Register the static-assets service worker for offline (PWA) support.
// Auto-update: when a NEW sw.js is detected, take control and reload the page
// so the latest bundle always runs — stale SW caches were serving old bundles
// and made the band switcher keep showing the previous band's data.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // New SW found → wait for it to activate (skipWaiting) then reload once.
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
            window.location.reload();
          }
        });
      });
    }).catch((err) => {
      console.error('Service worker registration failed:', err);
    });
  });
}
